import { render, staticRenderFns } from "./TicketGroups.vue?vue&type=template&id=0cea4ce0&scoped=true"
import script from "./TicketGroups.vue?vue&type=script&lang=js"
export * from "./TicketGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cea4ce0",
  null
  
)

export default component.exports